import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import {
  Opts,
  PagedResponse,
  QueryParams,
} from "@ofqual/portal-core/core/types";
import { paramsToSearchString } from "@ofqual/portal-core/core/utils/urlHelper";
import { LinkedRecord } from "../domain/LinkedRecord";
import { LinkedRecordCreate } from "../domain/LinkedRecordCreate";


const DEFAULT_PAGE_SIZE = 1000;
export class LinkedRecordsService extends BaseRemoteService {
  public async search(
    resourceId: string,
    params: QueryParams,
    opts: Opts
  ): Promise<PagedResponse<LinkedRecord>> {
    const url = `${
      this.apiRoot
    }/linkedrecords/${resourceId}/${paramsToSearchString({
      ...params,
      pageSize: DEFAULT_PAGE_SIZE,
    })}`;

    return await super.getRequest<PagedResponse<LinkedRecord>>(url, opts);
  }

  public async postLinkedRecord(
    resourceId: string,
    linkedRecord: LinkedRecordCreate,
    opts: Opts
  ) {
    try {
      const url = `${this.apiRoot}/linkedrecords/${resourceId}`;
      return await super.postRequest<LinkedRecordCreate>(
        url,
        linkedRecord,
        opts
      );
    } catch (err) {
      throw err;
    }
  }

  public async deleteLinkedRecord(id: string, opts: Opts)
  {
    try {
      const url = `${this.apiRoot}/linkedrecords/${id}`;
      return await super.deleteRequest(url, opts);
    } catch (err) {
      throw err;
    }
  }
}
